import React, { useEffect, useRef, useState } from 'react';
import Menu from './Menu';

import styles from './Navigation.module.css';

const SCROLL_STEP = 240;

const NavContainer = ({ role, setRole, navBurger }) => {
    const [leftArrow, setLeftArrow] = useState(false);
    const [rightArrow, setRightArrow] = useState(false);
    const scrollRef = useRef(null);

    const scrollBy = (dx) => {
        const el = scrollRef.current;
        if (!el) return;
        el.scrollBy({ left: dx, behavior: 'smooth' });
        requestAnimationFrame(() => updateArrows(el));
    };

    const updateArrows = (el) => {
        if (!el) return;
        const { scrollLeft, clientWidth, scrollWidth } = el;
        setLeftArrow(scrollLeft > 1);
        setRightArrow(scrollLeft + clientWidth < scrollWidth - 1);
    };

    function handleScroll(e) {
        updateArrows(e.currentTarget);
    }

    useEffect(() => {
        const handleResize = () => updateArrows(scrollRef.current);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <nav className={styles.navContainer}>
            {leftArrow && <>
                <button className={`${styles.boxArrow} ${styles.left}`} onClick={() => scrollBy(-SCROLL_STEP)}>
                    <img className={styles.arrows} src='/Navigation/arrowIcon.png' alt='' />
                </button>
            </>}
            <div onScroll={handleScroll} className={`${styles.navOptions} ${navBurger ? styles.mobileMenu : ''}`} ref={scrollRef}>
                <Menu role={role} setRole={setRole} navBurger={navBurger} />
            </div>
            {rightArrow && <>
                <button className={`${styles.boxArrow} ${styles.right}`} onClick={() => scrollBy(SCROLL_STEP)}>
                    <img className={styles.arrows} src='/Navigation/arrowIcon.png' alt='' />
                </button>
            </>}
        </nav>
    );
};

export default NavContainer;